import React, { Component } from 'react';
import ListingScreen from '../../custom/listingScreen/ListingScreen';
import ClientService from '../../../services/clients/ClientService';
import EditIcon from '@material-ui/icons/Edit';
import menuData from '../MenuDatas';

class DevisList extends Component {

    path = menuData.devisEdit.path;
    tableColumnsAction = [{ "icon": <EditIcon />, "label": "Modifier le devis", "className": "dataListModifier", "url": this.path, "typeAction": "open/edit" }]
    tableColumns = [{ "label": "Numéro", "className": "dataListNumero" }, { "label": "Date de création", "className": "dataDate" }, { "label": "Client", "className": "dataDevisListClient" }];
    labelRecherche = "Rechercher par numéro, nom ou prénom";
    labelCreation = "Créer un nouveau devis";

    getDataService(critere) {
        var clientService = new ClientService();
        return clientService.getAll(critere);
    }

    render() {
        return (
            <ListingScreen
                tableColumnsAction={this.tableColumnsAction}
                tableColumns={this.tableColumns}
                service={this.getDataService}
                path={this.path}
                labelRecherche={this.labelRecherche}
                labelCreation={this.labelCreation}
            />);
    }
}

export default DevisList;


// WEBPACK FOOTER //
// ./src/components/content/devisList/DevisList.js